module.exports = __webpack_public_path__ + "files/74868203b874ab87c22fb04b5360ba16.png";